<template>
    <div class="my-wechat">
        <mt-header fixed title="状态变更">
            <router-link to="/my" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">
            <mt-radio title="岗位状态" v-model="work_status" :options="options"></mt-radio>
            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="changeStatus">提交</mt-button>
            </div>
        </div>
    </div>
</template>
<script>

    export default{

        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                work_status:"0",

                options:[
                    {
                        label: '在岗',
                        value: "0",
                    },
                    {
                        label: '外出',
                        value: "1"
                    },
                    {
                        label: '会议',
                        value: "2"
                    },
                    {
                        label: '休假',
                        value: "3"
                    }
                ],
            }
        },
        methods:{

            changeStatus(){

                this.$indicator.open('加载中');
                let that = this;

                this.$axios.post("/my/status", {openid:this.openid,status:this.work_status})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.$toast('切换成功!');
                            that.$router.push('/my');
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            }

        },

        created(){
            this.$indicator.open('加载中');

            this.$axios.get("/my/status?openid="+this.openid)
                .then(data => {

                    this.$indicator.close();

                    if (data.data.code === 'OK') {
                        this.work_status = data.data.data;
                    } else {
                        this.$toast(data.data.message);
                    }
                });
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/my/status.vue